import arrays from './arrays';
import async from './async';
import casting from './casting';
import classes from './classes';
import functions from './functions';
import modules from './modules';
import objects from './objects';
import operators from './operators';
import strings from './strings';
import valueOrReference from './value-or-reference';
import variables from './variables';

export default {
  valueOrReference,
  casting,
  variables,
  objects,
  arrays,
  strings,
  functions,
  classes,
  modules,
  operators,
  async,
};
